// removed by extract-text-webpack-plugin
module.exports = {"secondCTA":"main_nav-2lT","single-button":"main_nav-XrD","pulse":"main_nav-vw5"};


//////////////////
// WEBPACK FOOTER
// ../src/components/CTA/cta.module.scss
// module id = 348
// module chunks = 0